/**
 * Calendar days, read and written the way the API stores them: `YYYY-MM-DD`.
 *
 * Deliberately not `src/utils/date.ts`, whose `formatDate` parses a bare day
 * through `new Date('YYYY-MM-DD')` — that is UTC midnight, which reads as the
 * day before anywhere west of Greenwich. A due date has no time in it, so it is
 * built and read as a local date throughout.
 */

/** The stored value as a local date, or undefined when there is none. */
export const toLocalDate = (value: string | null): Date | undefined => {
  if (!value) {
    return undefined;
  }

  const [ year, month, day ] = value.slice(0, 10).split('-').map(Number);

  return new Date(year, month - 1, day);
};

/** A picked date as the API's calendar day. */
export const toStoredDay = (date: Date): string => [
  date.getFullYear(),
  String(date.getMonth() + 1).padStart(2, '0'),
  String(date.getDate()).padStart(2, '0'),
].join('-');

/** How a date reads on the board, or null when there is none to show. */
export const formatTaskDate = (value: string | null): string | null =>
  toLocalDate(value)?.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }) ?? null;
